export default __webpack_public_path__ + "static/media/matematik.508490dd.jpeg";